@if (session) {
  @if (!!locked) {
    <div class="session-lock">
      <div class="lock-icon" (click)="openInfoDialog()">
        <mat-icon svgIcon="lock_v2"></mat-icon>
      </div>
      <span class="mt-3 mt-md-2 mx-3 mx-md-0 tooltip" translate>
        SINGLE_TRAINING.LOCKED
        <i-feather name="info" (click)="openInfoDialog()"></i-feather>
      </span>
    </div>
  }
  <div
    class="header d-flex"
    (click)="toggleExpand()"
    [matTooltipDisabled]="expanded"
    [matTooltip]="'SINGLE_TRAINING.EXPAND' | translate"
    matTooltipPosition="above">
    <app-circle [number]="number" [percentage]="percentage" [isMilestone]="isMilestone" [isFinal]="isFinal" [isFinished]="isFinished">
    </app-circle>
    <h2 class="title">
      @if (isMobile()) {
        <ng-template nestedEllipsis> {{session.title}} </ng-template>
      }
      @if (!isMobile()) {
        {{session.title}}
      }
    </h2>
    <div class="align-self-right header-toggle">
      @if (!expanded) {
        <mat-icon svgIcon="expand_v2"></mat-icon>
      }
      @if (expanded) {
        <mat-icon svgIcon="reduce_v2"></mat-icon>
      }
    </div>
  </div>
  <div class="body">
    <div class="row">
      @if (expanded) {
        <div class="col-12 col-lg-5">
          <div class="image-container">
            @if (session.image) {
              <img class="img-fluid" [appSrcset]="session.image?.url" [alt]="session.image?.alt" [pxWidth]="640" />
            }
          </div>
          <div class="p-3 p-sm-0 description" [innerHTML]="session.description | prismicHtml | hyphenateHtml | async"></div>
        </div>
        <div class="col mt-4 mt-lg-0">
          <ng-content></ng-content>
        </div>
      }
    </div>
  </div>
}
